import React from 'react';

const File = ({name, date, num, filled, onDelete}) => {
    return (
        <div className={`file${num === 10 ? " ten" : ""}${filled ? " fill" : ""}`} onClick={() => window.location.assign(`/file/${num}`)}>
            <span className="num-file">{num}.</span> <i className="icon-file"></i>
            <div style={{width: "100%", minWidth: "0"}}>
                <span className="file-name">{name}</span><br/>
                <span className="file-date">{date}</span>
                {filled && <i className="icon-trash" style={{cursor: "pointer"}} onClick={(e) => {e.stopPropagation(); onDelete(num)}}></i>}
            </div>
        </div>
    );
};

export default File;